import React, {useCallback, useEffect, useRef, useState} from 'react';
import PropTypes from 'prop-types';

import {Wrapper, CounterLabel, CounterWrapper} from './Charts.styles';
import Counter from './Counter';
import Population from './Population';
import BottomChart from './BottomChart';
import {debounce} from '../../../lib/helpers';

const ChartsDisplay = ({
  lang,
  activeChart,
  activeYear,
  data,
  populationCount,
  abstractionCount,
  waterPerCapita,
}) => {
  const [{width, height}, setDimensions] = useState({
    width: window.innerWidth,
    height: window.innerHeight / 2,
  });

  const wrapperRef = useRef();

  const updateDimensions = useCallback(() => {
    setDimensions({
      width: wrapperRef.current.clientWidth,
      height: wrapperRef.current.clientHeight / 2,
    });
  }, []);

  const onResize = debounce(updateDimensions, 250);

  useEffect(() => {
    setDimensions({
      width: wrapperRef.current.clientWidth,
      height: wrapperRef.current.clientHeight / 2,
    });
  }, []);

  useEffect(() => {
    window.addEventListener('resize', onResize);

    return function cleanup() {
      window.removeEventListener('resize', onResize);
    };
  }, [onResize]);

  return (
    <Wrapper ref={wrapperRef} width={width} height={height}>
      <div className='chart'>
        <Population
          lang={lang}
          activeYear={activeYear}
          height={height}
          width={width}
          data={data}
        />
        <CounterWrapper className='top'>
          <CounterLabel>
            {lang === 'en' ? 'Population' : 'السّكّان'}
          </CounterLabel>
          <Counter data={populationCount} />
        </CounterWrapper>
      </div>
      {activeChart === 'abstraction' && (
        <div className='chart'>
          <BottomChart
            lang={lang}
            activeYear={activeYear}
            height={height}
            width={width}
            data={data}
            id='overAbstraction'
          />
          <CounterWrapper className='bottom'>
            <CounterLabel>
              {lang === 'en' ? 'Over-abstraction (MCM)' : 'الضّخ الجائر'}
            </CounterLabel>
            <Counter data={abstractionCount} />
          </CounterWrapper>
        </div>
      )}
      {activeChart === 'wpc' && (
        <div className='chart'>
          <BottomChart
            lang={lang}
            activeYear={activeYear}
            height={height}
            width={width}
            data={data}
            id='waterPerCapita'
          />
          <CounterWrapper className='bottom'>
            <CounterLabel>
              {lang === 'en'
                ? 'Available Water Per Capita (m3/year)'
                : 'المياه المتوفّرة للفرد'}
            </CounterLabel>
            <Counter data={waterPerCapita} />
          </CounterWrapper>
        </div>
      )}
    </Wrapper>
  );
};

ChartsDisplay.propTypes = {
  lang: PropTypes.string,
  activeChart: PropTypes.string,
  activeYear: PropTypes.number,
  data: PropTypes.array,
  populationCount: PropTypes.object,
  abstractionCount: PropTypes.object,
  waterPerCapita: PropTypes.object,
};

export default ChartsDisplay;
